import React from 'react';
import { Icon } from '@hydrodigital/design-system';
import type { AlertCardType } from '@/domain/Notifications/Notifications';
import { resolveThresholdLabel } from '../constants';
import BaseCard from '../components/BaseCard';

interface SystemAlertCardProps {
	readonly act: AlertCardType & { onDismiss?: () => void };
}

export default function SystemAlertCard({ act }: SystemAlertCardProps) {
	const unit = act.parameterUnit ? ` ${act.parameterUnit}` : '';
	const val = typeof act.alertValue === 'string' ? Number.parseFloat(act.alertValue) : (act.alertValue ?? Number.NaN);
	const currentValueLabel = Number.isFinite(val) ? `${val}${unit}` : '-';
	const thresholdLabel = resolveThresholdLabel(act, unit);

	return (
		<BaseCard
			act={act}
			titleContent={<span>{act.title}</span>}
			messageContent={act.message}
			expandedContent={
				<div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 6, color: '#000' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
						<Icon name="map-marker" color="#000" />
						<span style={{ fontWeight: 600 }}>{act.locationName}</span>
					</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
						<Icon name="valve" color="#000" />
						<span style={{ fontWeight: 600 }}>{act.infrastructureType}: </span>
						{act.infrastructureName}
					</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
						<Icon name="windsock" color="#000" />
						<span style={{ fontWeight: 600 }}>{currentValueLabel}</span>
						<Icon name="check-circle" color="#000" style={{ marginLeft: 12, fontSize: 14 }} />
						<span style={{ fontWeight: 600 }}>{thresholdLabel}</span>
					</div>
				</div>
			}
		/>
	);
}
